import React from "react";

const CameraIcon = ({ size }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width={size}
      height={size}
      x="0"
      y="0"
      viewBox="0 0 612 612"
    >
      <g>
        <g xmlns="http://www.w3.org/2000/svg">
          <g id="_x34__29_">
            <g>
              <path
                d="M535.5,114.75h-57.375L459,76.5c-11.265-22.262-17.117-38.25-38.25-38.25h-229.5c-21.133,0-28.114,18.245-38.25,38.25     l-19.125,38.25H76.5c-42.247,0-76.5,34.253-76.5,76.5v306c0,42.247,34.253,76.5,76.5,76.5h459c42.247,0,76.5-34.253,76.5-76.5     v-306C612,149.003,577.747,114.75,535.5,114.75z M573.75,497.25c0,21.133-17.117,38.25-38.25,38.25h-459     c-21.133,0-38.25-17.117-38.25-38.25v-306c0-21.114,17.117-38.25,38.25-38.25H153l19.125-38.25     c13.521-22.242,17.117-38.25,38.25-38.25h191.25c21.133,0,24.729,15.988,38.25,38.25L459,153h76.5     c21.133,0,38.25,17.117,38.25,38.25V497.25z M306,191.25c-84.494,0-153,68.506-153,153s68.506,153,153,153s153-68.506,153-153     S390.494,191.25,306,191.25z M306,459c-63.38,0-114.75-51.37-114.75-114.75c0-63.38,51.37-114.75,114.75-114.75     c63.38,0,114.75,51.37,114.75,114.75C420.75,407.63,369.38,459,306,459z"
                fill="#ffffff"
                data-original="#000000"
              />
            </g>
          </g>
        </g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
      </g>
    </svg>
  );
};
export default CameraIcon;
